import { useRef } from 'react';

interface LazyLoadMetrics {
  loadTime: number;
  intersectionTime: number;
  totalTime: number;
}

export const useLazyLoadPerformance = (sectionName: string) => {
  const startTime = useRef<number>(Date.now());
  const intersectionTime = useRef<number | null>(null);
  const loadTime = useRef<number | null>(null);

  const recordIntersection = () => {
    if (!intersectionTime.current) {
      intersectionTime.current = Date.now();
    }
  };

  const recordLoad = () => {
    if (!loadTime.current) {
      loadTime.current = Date.now();
      
      const metrics: LazyLoadMetrics = {
        loadTime: loadTime.current - (intersectionTime.current || startTime.current),
        intersectionTime: intersectionTime.current ? intersectionTime.current - startTime.current : 0,
        totalTime: loadTime.current - startTime.current,
      };

      // Log performance metrics
      console.log(`Lazy Load Performance - ${sectionName}:`, metrics);
      
      // You can send this to analytics service here
      // analytics.track('lazy_load_performance', { section: sectionName, ...metrics });
    }
  };

  return {
    recordIntersection,
    recordLoad,
  };
}; 